import React, { useEffect, useState } from "react";
import axios from "axios";

function HoverBioHistory(props) {
	const [data, setData] = useState([]);
	useEffect(() => {
		if (props.data0) {
			setData(props.data0);
		} else {
			axios.get("/api/history/bio?mid=" + props.uid).then((response) => {
				setData(response.data.data);
			});
		}
	}, []);
	return (
		<div>
			{data.map((item, index) => {
				return (
					<p className={"mt-3"}>
						<p className={"mr-2 text-gray-400"}>
							{new Date(item.CreatedAt).toLocaleDateString()}
						</p>
						{item.Bio}
					</p>
				);
			})}
		</div>
	);
}

export default HoverBioHistory;
